'use strict';
/**
 * Procedural country-flag textures for the rear flag accessory
 * (gltf-tank-kit.js). Canvas-drawn - same CanvasTexture idiom menu-tank.js's
 * decal star and tank-gallery.js's ground texture already use - so no SVG
 * loader is needed for simple geometric flags. Registry keyed by a short
 * country id so adding more flags later is additive, not a rewrite.
 *
 * `shape` distinguishes square vs. (future) rectangle flags; a freeform
 * silhouette (e.g. a swallowtail) would need its own geometry, not just a
 * texture - not implemented here, only the Swiss flag (square) is.
 */
import * as THREE from 'three';

export const FLAGS = {
  ch: {
    shape: 'square',
    aspect: 1, // width / height
    draw(ctx, w, h) {
      ctx.fillStyle = '#d52b1e';
      ctx.fillRect(0, 0, w, h);
      ctx.fillStyle = '#ffffff';
      const armW = w * 0.2;
      const armLen = h * 0.62;
      ctx.fillRect((w - armW) / 2, (h - armLen) / 2, armW, armLen);
      ctx.fillRect((w - armLen) / 2, (h - armW) / 2, armLen, armW);
    },
  },
};

const textureCache = new Map();

export function buildFlagTexture(countryId) {
  const id = FLAGS[countryId] ? countryId : 'ch';
  if (textureCache.has(id)) return textureCache.get(id);

  const def = FLAGS[id];
  const size = 128;
  const w = size;
  const h = Math.round(size / def.aspect);
  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  def.draw(ctx, w, h);

  const texture = new THREE.CanvasTexture(canvas);
  texture.colorSpace = THREE.SRGBColorSpace;
  const result = { texture, aspect: def.aspect, shape: def.shape };
  textureCache.set(id, result);
  return result;
}
